import Vue from "vue";
import api from "@axios";
import store from "@/store";
import { convertHTMLEntity } from "@/global/functions.js";

// IMEI Check Service
class ImeiCheck {
    // Single check
    static async single(formData, servicePrice = 0) {
        try {
            api.defaults.headers.post["version"] = "v5.0"; // Set API version
            const { data } = await api.post("/imei/single", formData);
            
            // Decrease Balance only if servicePrice is valid
            if (servicePrice > 0) {
                store.commit("HANDLE_CREDIT", -servicePrice);
            }

            return data;
        } catch (error) {
            console.error("Single check error:", error);
            await this.handleErrorPopup(error);
            throw error;
        }
    }

    // Bulk check
    static async bulk({ imei, service_id, mail, ...rest }) {
        try {
            const imeis = [...new Set(imei.split("\n").map(e => e.trim()))].filter(Boolean);

            api.defaults.headers.post["version"] = "v5.0"; // Set API version
            const { data } = await api.post("/imei/bulk", { imeis, service_id, mail, ...rest });

            return data;
        } catch (error) {
            console.error("Bulk check error:", error);
            await this.handleErrorPopup(error);
            throw error;
        }
    }

    // Handle error popups
    static async handleErrorPopup(error) {
        // Network error / timeout — no response at all
        if (!error.response) {
            console.error("Unexpected error:", error);
            await Vue.prototype.$swal({
                title: "Connection Error",
                text: "Could not reach the server. Please check your connection and try again.",
                icon: "error",
                confirmButtonText: "OK",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
            });
            return;
        }

        // Guard: response.data might be string (plain text 500) or missing
        const rawData = error.response.data;
        const data = (rawData && typeof rawData === 'object') ? rawData : {};
        const { response: resErr, popup, errors } = data;
        const status = error.response.status;

        // Skip popup for duplicate — handled by Check.vue's duplicate modal
        if (data.status === "duplicate") return;

        // Outdated version — force reload once
        if (data.outdated) {
            const reloadKey = 'outdated_reload';
            if (!sessionStorage.getItem(reloadKey)) {
                sessionStorage.setItem(reloadKey, '1');
                window.location.reload(true);
                return;
            }
            // Already reloaded once, clear flag and show message
            sessionStorage.removeItem(reloadKey);
        }

        let errorMessage = "Server error..";
        if (status === 403) {
            errorMessage = resErr || "Access denied.";
        } else if (status === 422 && errors) {
            errorMessage = Object.values(errors)?.[0]?.[0] || "Validation error.";
        } else if (status === 429) {
            errorMessage = resErr || "Too many requests. Please wait a moment and try again.";
        } else if (status >= 500) {
            errorMessage = resErr || "Server error. Please try again later.";
        } else if (resErr) {
            errorMessage = resErr;
        }

        console.log("API Error Response:", error.response.data);

        // Always show popup — user must know something went wrong
        await Vue.prototype.$swal({
            title: "Error",
            html: convertHTMLEntity(errorMessage),
            icon: "error",
            confirmButtonText: "Ok, understand",
            customClass: {
                confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
        });
    }
}

export default ImeiCheck;